// @flow
export default (selectbox, placeholder) => {
  const firstOption = selectbox.children('option:first');
  firstOption.attr({
    value: '',
    disabled: true,
    hidden: true,
  });
  firstOption.html(placeholder);
};
